import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-54412f62"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src"]
const _hoisted_2 = { class: "summary16167-choice__label" }

import { computed } from 'vue'

import { getImage, QuestionnaireView } from '@/models/onboarding'
import { GenreSelection16167Page, OptionsPage } from '@/models/onboarding.types'
import { PublicInterface } from '@/models/interfaces'

import { assertNotNull } from '@/helpers/typing'


export default /*#__PURE__*/_defineComponent({
  __name: 'Summary16167Choices',
  props: {
    view: null,
    pageID: null,
    userChoices: null
  },
  setup(__props: any) {

const props = __props as {
  view: PublicInterface<QuestionnaireView>
  pageID: 'what-prevents-you' | 'genre-selection'
  userChoices: string[]
};



const optionsData = computed(() => {
  const pageData = props.view.getPage(props.pageID) as
    | OptionsPage
    | GenreSelection16167Page

  const options = pageData.options

  return props.userChoices.map((choice) => {
    const optionData = options.find(
      // @ts-expect-error - Options in the OptionsPage don't have IDs,
      // so we use the label as a fallback.
      (option) => (option.id ?? option.label) === choice,
    )

    const icon = assertNotNull(optionData?.icon)
    const label = assertNotNull(optionData?.label)

    return {
      label,
      icon,
    }
  })
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(optionsData), (choice) => {
    return (_openBlock(), _createElementBlock("li", {
      key: choice.label,
      class: "summary16167-choice"
    }, [
      _createElementVNode("img", {
        src: _unref(getImage)(choice.icon),
        width: "32",
        height: "32",
        alt: "",
        class: "summary16167-choice__icon"
      }, null, 8, _hoisted_1),
      _createElementVNode("p", _hoisted_2, _toDisplayString(choice.label), 1)
    ]))
  }), 128))
}
}

})